const styles = {
  errorWarningContainer: {
    px: 2,
    pb: 0,
    mb: 6,
    color: "error.light",
  },
};

export default styles;
